import React, { Component, Fragment } from "react";
import { DraggableModal } from "../../../components";
import { Form, Input, Select, Button, message } from "antd";
import Axios from "axios";
import AxiosFormData from "../../../helpers/AxiosFormData";
import { injectIntl, FormattedMessage } from "react-intl";
import { ajaxUrl } from "../../../config/constants";
import { product } from "../../../../config/constants";
const package_version = 'app';

class ServicesGroupModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lockForm: false,
      message: null,
      name: '',
      servicesGroup: props.servicesGroup, 
      _getSelect2Service: [],
      titlePrefix: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.id !== prevProps.id) {
      const { id, intl } = this.props;
      if (id) {
        this.setState({ lockForm: true })
        Axios.post(ajaxUrl[package_version].objects, AxiosFormData({ act: "getObjectGroup", type: "services", id })).then((res) => {
          if (res.data) {
            let servicesGroup = res.data[0];

            this.setState({
              servicesGroup: {
                lockForm: false,
								id: servicesGroup.id,
								name: servicesGroup.name,
								description: servicesGroup.desc,
								list: JSON.parse(servicesGroup.id_objs),
                type: servicesGroup.type,
                gsmid: servicesGroup.gsmid
              }
            }, () => {
              this.setState({ lockForm: false })
            })
          }
        })
      }

      this.state.titlePrefix = intl.formatMessage({id: 'common.edit'});
      this._getSelect2Service();
    }

    if (this.props.servicesGroup !== prevProps.servicesGroup) {
      this.setState({
        lockForm: false,
        servicesGroup: this.props.servicesGroup,
      })

    }
  }

  _getSelect2Service = () => {
		const formData = new FormData();
		formData.set("act", "_getSelect2Service");
		Axios.post(ajaxUrl[package_version].objects_templates, formData).then((res) => {
			this.setState({ _getSelect2Service: res.data.items });
		});
	}

  handleSave = () => {
    const { intl } = this.props;
    const { servicesGroup } = this.state;
    this.setState({ loading: true, lockForm: true });

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { group, form } = this.props;
        const bodyData = new FormData();
        bodyData.set("act", "saveObjectsGroups");
        bodyData.set("table", 'services');
        bodyData.set("obj_services_group-type", 'group');
        bodyData.set("obj_services_group-name", values["obj_services_group-name"]);
        bodyData.set("obj_services_group-desc", values["obj_services_group-desc"]);
        bodyData.set("obj_services_group-list", values["obj_services_group-list"]);

        if (group && "id" in group){
          bodyData.set("obj_services_group-id", group.id);
        } else if (servicesGroup && servicesGroup.id) {
          bodyData.set(`obj_services_group-id`, servicesGroup.id);
        }

        Axios.post(ajaxUrl[package_version].objects, bodyData).then((res) => {
          this.setState({ lockForm: false, loading: false });

          if (product == "GSM" && Array.isArray(res.data) && res.data.length == 2)
            if (res.data[1]['errorcode'] == '001') {
              this.props.form.resetFields();
              this.handleCancel();
              return message.error(this.props.intl.formatMessage({ id: "common.dont.permission" }))
            }

            if (res.data === "Seu login não permite acesso a esta area." || res.data === "Your login does not allow access to this area.") {
            this.props.form.resetFields();
            this.handleCancel();
            return message.error(this.props.intl.formatMessage({ id: "common.dont.permission.edit" }));
          } else if (res.data === "High Availabilty Habilitado - Estado: Backup - Acesso Bloqueado." || res.data === "High Availabilty Enabled - State: Backup - Blocked Access.") {
            this.props.form.resetFields();
            this.handleCancel();
            return message.error(this.props.intl.formatMessage({ id: "common.blocked.ha" }));
          } 

          if (res.data[0].success == 1) {
            message.success(intl.formatMessage({ id: "objects.address.modal.save.success" }));
            this.props.form.resetFields();
            this.handleCancel();
            this.props.onSuccess();
          } else {

            res.data.forEach(erro => {
              form.setFields({
                [erro.field]: {
                  value: values[erro.field],
                  errors: [new Error(intl.formatMessage({ id: "common.invalid.value" }))],
                },
              });

              if (res.data[0]['exists']) {
                form.setFields({
                  'obj_services_group-name': {
                    value: form.getFieldValue('obj_services_group-name'),
                    errors: [new Error(this.props.intl.formatMessage({ id: "common.alreadyExists" }))]
                  }
                })
              }
            })
            message.error(intl.formatMessage({ id: "objects.actions.create.error" }));
          }
        });
      } else {
        this.setState({ lockForm: false });
      }
    });
  }

  handleCancel = () => {
    const { onCancel } = this.props;
    this.props.form.resetFields();
    onCancel();
  }

  renderServices() {
    if(this.props._getSelect2Service){
      const { _getSelect2Service } = this.props;
      if (_getSelect2Service){
        return _getSelect2Service.map((g) => {
          return <Select.Option key={g.id} value={g.id}>{g.text}</Select.Option>;
        });
      }
    }
    if(this.state._getSelect2Service){
      const { _getSelect2Service } = this.state;
      if ( _getSelect2Service ) {
        return _getSelect2Service.map((g) => {
          return <Select.Option key={g.id} value={g.id}>{g.text}</Select.Option>;
        });
      }
    }
  }

  render() {

    let { intl, visible, group, titlePrefix } = this.props;
    const { lockForm, servicesGroup } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { TextArea } = Input;
    const formLayout = { colon: false, style: { paddingBottom: 0 } };

    let lockFormGsmUtm = lockForm;
    let controleLoadingButton = false;

    if (servicesGroup){
      group = servicesGroup;
      group.list = group.list.map(i => parseInt(i));
    }

    titlePrefix = titlePrefix ? titlePrefix : this.state.titlePrefix;

    let rows = [];
    if (group) {

      //Object GSM disabled
      lockFormGsmUtm = group.gsmid ? true : lockForm;
      controleLoadingButton = group.gsmid ? false : lockForm;

      if (group.id !== undefined) {
        if (group.list.length == 0) {
          rows = group.list;
        } else {
          rows = Array.isArray(group.list) ? group.list : JSON.parse(group.list);
        }
      }
    } else {
      group = [];
    }

    const footerActions = [
			<Button key="cancel" onClick={this.handleCancel}>
				<FormattedMessage id="common.cancel" />
			</Button>,
			<Button loading={controleLoadingButton} disabled={lockFormGsmUtm} key="save" type="primary" onClick={this.handleSave}>
				<FormattedMessage id="common.save" />
			</Button>
		]

    return <DraggableModal
      onOk={this.handleSave}
      onCancel={this.handleCancel}
      confirmLoading={lockFormGsmUtm}
      visible={visible}
      title={<Fragment>{titlePrefix}<FormattedMessage id="objects.modal.group.title" values={{ object: intl.formatMessage({ id: "common.object.service" }) }} /></Fragment>}
      okText={intl.formatMessage({ id: "common.save" })}
      cancelText={intl.formatMessage({ id: "common.cancel" })}
      footer={footerActions}>
      <Form id="form-address-group" layout="vertical">
        <Form.Item {...formLayout} label={intl.formatMessage({ id: "objects.address.modal.form.name" })} >
          {getFieldDecorator('obj_services_group-name', {
            initialValue: group.name,
            rules: [{ required: true, message: intl.formatMessage({ id: "common.error.required" }, { name: intl.formatMessage({ id: "objects.address.modal.form.name" }) }) }]
          })(
            <Input disabled={lockFormGsmUtm} />
          )}
        </Form.Item>

        <Form.Item {...formLayout} label={intl.formatMessage({ id: "objects.address.modal.form.description" })} >
          {getFieldDecorator('obj_services_group-desc', {
            initialValue: group.description,
          })(
            <TextArea disabled={lockFormGsmUtm} />
          )}
        </Form.Item>

        <Form.Item {...formLayout} label={intl.formatMessage({ id: "objects.addressGroup.modal.object" })}>
          {getFieldDecorator('obj_services_group-list', {
            initialValue: rows,
            rules: [{ required: true, message: intl.formatMessage({ id: "common.error.required" }, { name: intl.formatMessage({ id: "objects.addressGroup.modal.object" }) }) }]
          })(
            <Select
              disabled={lockFormGsmUtm}
              style={{ width: "100%" }}
              showSearch
              placeholder="Select"
              optionFilterProp="children"
              mode="multiple"
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {this.renderServices()}
            </Select>
          )}
        </Form.Item>

      </Form >
    </DraggableModal>
  }
}

ServicesGroupModal.defaultProps = {
  onCancel: null,
  visible: false
}

export default injectIntl(Form.create({})(ServicesGroupModal));